import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  if (req.headers.has('Authorization')) return next(req);
  const token = localStorage.getItem('bs_token');
  if (token) {
    req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
  return next(req).pipe(
    catchError((error: unknown) => {
      const isUnauthorized = error instanceof HttpErrorResponse && error.status === 401;
      const isAuthEndpoint = req.url.includes('/auth/login') || req.url.includes('/auth/register');
      const isAdminEndpoint = req.url.includes('/admin/');

      if (isUnauthorized && !isAuthEndpoint && !isAdminEndpoint) {
        auth.handleUnauthorized();
      }

      return throwError(() => error);
    }),
  );
};
